function ProfileList(props) {
  const {children} = props;
  return (
    <ul className={`profile-list ${props.className || ''}`}>
     {children}
    </ul>
  );
}
export default ProfileList;
